import { PortalIdentity } from './shell/PortalIdentity';
import { Button } from './ui/Button';

/**
 * Unauthenticated landing (PRO-0250 §5; reskinned PRO-0260 Phase 1; rebranded
 * PRO-0340 portal identity). Owns its own single `<main>` landmark and the
 * sign-in affordance. The app stays deny-by-default: nothing else renders until
 * the user authenticates via Entra ID. Token-first chrome; the 44px CTA and
 * single main are preserved from PRO-0250.
 */
export function LandingView({ onSignIn }: { onSignIn: () => void }) {
  return (
    <main className="mx-auto flex min-h-screen max-w-narrow flex-col justify-center px-4 py-16">
      <div className="rounded-lg border border-border bg-surface p-8 shadow-md">
        <PortalIdentity titleAs="h1" className="mb-6" />
        <p className="mb-6 text-base text-text-secondary">
          Staff sign in with their Aurora (Microsoft Entra ID) account to access TAG Operations
          modules.
        </p>
        <Button onClick={onSignIn}>Sign in with Microsoft</Button>
      </div>
    </main>
  );
}
